module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp23_7016.fa530890.png";